import { Box, TextField, Typography } from '@mui/material';

const TransportPoint = ({ value = {}, onChange, label }) => (
  <Box display="flex" flexDirection="column" gap={1}>
    <Typography variant="subtitle2">{label}</Typography>

    <TextField
      variant="filled"
      label="Name"
      value={value.name || ''}
      onChange={(e) =>
        onChange({ ...value, name: e.target.value })
      }
    />

    <TextField
      variant="filled"
      type="number"
      label="Latitude"
      value={value.latitude || ''}
      onChange={(e) =>
        onChange({ ...value, latitude: e.target.value })
      }
    />

    <TextField
      variant="filled"
      type="number"
      label="Longitude"
      value={value.longitude || ''}
      onChange={(e) =>
        onChange({ ...value, longitude: e.target.value })
      }
    />
  </Box>
);

export default TransportPoint;
